import { Injectable } from '@angular/core';
import { CrudService } from 'app/shared/crud-service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { DepositoDTO } from './deposito.model';

@Injectable({
    providedIn: 'root'
})
export class DepositoService extends CrudService<DepositoDTO> implements Resolve<any>{
    routeParams: any;

    constructor(protected http: HttpClient) {
        super(http, `${environment.apiUrl}/v1/Deposito`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        if (this.routeParams.id === 'new') {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }

    deleteDeposito(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${environment.apiUrl}/v1/Deposito/${id}`)
                .subscribe((response: any) => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
        });
    }
}
